import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["details", "indicator"]

  toggle() {
    if (!this.hasDetailsTarget) return
    this.detailsTarget.hidden = !this.detailsTarget.hidden
    if (this.hasIndicatorTarget) {
      this.indicatorTarget.textContent = this.detailsTarget.hidden ? "▸" : "▾"
    }
  }
}
